export type ConnectedEntitiesInfo = {
    projects: Array<unknown>;
    landfills: Array<unknown>;
    users: Array<unknown>;
};

export const hasConnectedEntities = (data: ConnectedEntitiesInfo) => {
    return data.projects.length + data.landfills.length + data.users.length > 0;
};
